/* eslint-disable prettier/prettier */
/* prettier-ignore-file */
/* eslint-disable */

import { useState } from 'react';
import { userService } from '../services/userService';
import { UpdateUserRoleRequest } from '../types/user'; // ✅ FIX

export const useAdminUser = () => {
	const [loading, setLoading] = useState(false);
	const [error, setError] = useState<string | null>(null);
	const [success, setSuccess] = useState(false);

	const updateUserById = async (
		userId: string,
		data: UpdateUserRoleRequest
	) => {
		setLoading(true);
		setError(null);
		setSuccess(false);

		try {
			const res = await userService.updateUserById(userId, data);

			if (res.success) {
				setSuccess(true);
			} else {
				setError(res.message);
			}
		} catch (err: any) {
			setError(err.message || 'Failed to update user');
		} finally {
			setLoading(false);
		}
	};

	return {
		updateUserById,
		loading,
		error,
		success,
	};
};
